import { useUser } from "providers/UserProvider";
import { useState } from "react";
import { AuthService } from "services/authService";
import { useHistory } from "react-router-dom";

export const useLoginSkolFederationen = () => {
  const history = useHistory();
  const { setUser } = useUser();
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState(false);

  const handleLogin = (entityId: string) => {
    try {
      const result = AuthService.loginWithSkolFed(entityId);
      return result;
    } catch (e) {}
  };

  return { handleLogin, isLoading, authError };
};
